import React from 'react';
import Avatar from '@atlaskit/avatar';
import type { FieldKey } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import type { LocalIssueId } from '@atlassian/jira-polaris-domain-idea/src/idea/types.tsx';
import { useUser } from '../../../../controllers/issue/selectors/properties/hooks.tsx';

type Props = {
	localIssueId: LocalIssueId;
	fieldKey: FieldKey;
};

export const UserField = ({ localIssueId, fieldKey }: Props) => {
	const user = useUser(fieldKey, localIssueId);

	if (!user) {
		return null;
	}

	const avatarUrl = user.avatarUrls?.['48x48'];

	if (!avatarUrl) {
		return null;
	}

	return <Avatar size="xsmall" src={avatarUrl} name={user.displayName} />;
};
